export function helpOpen(type, filter) {
	return {
    type: 'HELP_GET',
    payload: {
			type: type,
			filter: filter,
		},
	}
}

export function helpClose() {
	return {
    type: 'HELP_INIT',
	}
}

export function helpAnswerToggle(id) {
	return {
    type: 'HELP_ANSWER_TOGGLE',
    payload: {
			id: id,
		},
	}
}
